import { render, staticRenderFns } from "./AppointmentEditingHistory.vue?vue&type=template&id=5870b747"
import script from "./AppointmentEditingHistory.vue?vue&type=script&lang=js"
export * from "./AppointmentEditingHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports